(() => {
  if (window.pawceGoldenHourLoaded) return;
  window.pawceGoldenHourLoaded = true;
  let dialogOpener = null;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-gh-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.ghOpen);
      if (dialog) { dialogOpener = opener; dialog.showModal(); }
    }
    const closer = event.target.closest('[data-gh-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', () => { dialogOpener?.focus(); dialogOpener = null; }, true);
  if (!customElements.get('gh-gallery')) customElements.define('gh-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gh-thumb]');
        if (!thumb) return;
        const index = Number(thumb.dataset.ghThumb);
        this.querySelectorAll('[data-gh-slide]').forEach((slide,i) => { slide.hidden = i !== index; });
        this.querySelectorAll('[data-gh-thumb]').forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));
      });
    }
  });
  if (!customElements.get('gh-product')) customElements.define('gh-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const form = this.querySelector('form');
      const formatMoney = cents => {
        const currency = this.dataset.currency || 'USD';
        const parts = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency,currencyDisplay:'code'}).formatToParts(cents / 100);
        const prefix = {USD:'US$',AUD:'A$'}[currency];
        return prefix ? prefix + parts.filter(part => !['currency','literal'].includes(part.type)).map(part => part.value).join('') : parts.map(part => part.value).join('');
      };
      const selectedPlan = () => form.querySelector('[data-gh-plan-radio]:checked');
      const updatePlan = () => {
        const plan = selectedPlan();
        if (!plan) return;
        this.querySelector('[data-gh-purchase-label]').textContent = plan.dataset.title;
        const quantity = Number(form.querySelector('[name="quantity"]').value) || 1;
        this.querySelector('[data-gh-price]').textContent = quantity === 1 ? plan.dataset.price : formatMoney(Number(plan.dataset.cents) * quantity);
        this.querySelector('[data-gh-unit]').textContent = plan.dataset.unit;
        this.querySelector('[data-gh-plan-note]').hidden = !plan.value;
        this.querySelector('[data-gh-renewal-price]').textContent = plan.dataset.price;
        const button = form.querySelector('[type="submit"]');
        if (!button.disabled) button.textContent = (plan.value ? button.dataset.subscribeLabel : button.dataset.onceLabel) + ' \u2197';
      };
      form.addEventListener('change', event => {
        if (event.target.matches('[data-gh-plan-radio], [name="quantity"]')) updatePlan();
      });
      form.addEventListener('input', event => {
        if (event.target.matches('[name="quantity"]')) updatePlan();
      });
      updatePlan();
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const button = form.querySelector('[type="submit"]');
        const status = this.querySelector('.gh-status');
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        status.textContent = '';
        try {
          const data = new FormData(form);
          const plan = selectedPlan();
          data.delete('gh_purchase_option');
          if (plan?.value) data.set('selling_plan', plan.value);
          else data.delete('selling_plan');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept:'application/json' }});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          const dialog = this.querySelector('dialog');
          const amount = formatMoney(result.final_line_price);
          dialog.querySelector('[data-gh-cart-detail]').textContent = result.quantity + ' × ' + result.product_title + ' · ' + amount;
          dialog.querySelector('[data-gh-cart-plan]').textContent = result.selling_plan_allocation?.selling_plan?.name || selectedPlan()?.dataset.title || '';
          dialogOpener = button;
          dialog.showModal();
          status.textContent = this.dataset.added;
          const cartResponse = await fetch(root + 'cart.js', { headers:{Accept:'application/json'} });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-gh-count]').forEach(el => { el.textContent = cart.item_count; });
          }
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
        } finally {
          button.disabled = false;
          button.innerHTML = original;
          updatePlan();
        }
      });
    }
  });
})();

if (!customElements.get('gh-sticky')) customElements.define('gh-sticky', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const product = document.querySelector('gh-product');
    const form = product?.querySelector('form');
    const mainButton = form?.querySelector('[type="submit"]');
    const button = this.querySelector('[data-gh-sticky-add]');
    if (!form || !mainButton || !button) return;
    const oneTime = this.querySelector('small').textContent;
    const sync = () => {
      button.disabled = mainButton.disabled;
      this.querySelector('[data-gh-sticky-price]').textContent = product.querySelector('[data-gh-price]').textContent;
      this.querySelector('small').textContent = product.querySelector('[data-gh-purchase-label]').textContent || oneTime;
      button.textContent = mainButton.textContent;
    };
    this.observer = new IntersectionObserver(entries => {
      this.hidden = entries[0].isIntersecting;
    }, {threshold:0.5});
    this.observer.observe(mainButton);
    this.mutations = new MutationObserver(sync);
    this.mutations.observe(mainButton, {attributes:true,attributeFilter:['disabled']});
    form.addEventListener('change', sync);
    form.addEventListener('input', sync);
    button.addEventListener('click', () => {
      if (mainButton.disabled) return;
      if (!form.checkValidity()) {
        form.scrollIntoView({behavior:'smooth',block:'center'});
        form.reportValidity();
        return;
      }
      form.requestSubmit(mainButton);
    });
    sync();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.mutations?.disconnect();
    this.initialized = false;
  }
});
